namespace TabAurous.OMS {
    export interface KaratRateRow {
        CostId?: number;
        ProductId?: number;
        AttributeId?: number;
        FromWt?: number;
        ToWt?: number;
        FromDate?: string;
        ToDate?: string;
        PurStdRate?: number;
        SaleStdRate?: number;
        ItemTypeId?: number;
        ProductTypeId?: number;
        ProductTypeName?: string;
        KaratId?: number;
        KaratCode?: string;
    }

    export namespace KaratRateRow {
        export const idProperty = 'CostId';
        export const localTextPrefix = 'OMS.KaratRate';
        export const lookupKey = 'OMS.KaratRate';

        export function getLookup(): Q.Lookup<KaratRateRow> {
            return Q.getLookup<KaratRateRow>('OMS.KaratRate');
        }
        export const deletePermission = 'Products:Delete';
        export const insertPermission = 'Products:Add';
        export const readPermission = '*';
        export const updatePermission = 'Products:Edit';

        export declare const enum Fields {
            CostId = "CostId",
            ProductId = "ProductId",
            AttributeId = "AttributeId",
            FromWt = "FromWt",
            ToWt = "ToWt",
            FromDate = "FromDate",
            ToDate = "ToDate",
            PurStdRate = "PurStdRate",
            SaleStdRate = "SaleStdRate",
            ItemTypeId = "ItemTypeId",
            ProductTypeId = "ProductTypeId",
            ProductTypeName = "ProductTypeName",
            KaratId = "KaratId",
            KaratCode = "KaratCode"
        }
    }
}
